import { isSearchDebugLoggingEnabled } from './logging';

export const SEARCH_DEBUG_PREFIX = '[SearchDebug]';

export const searchDebugLog = (...args: any[]) => {
  if (!isSearchDebugLoggingEnabled()) return;
  // eslint-disable-next-line no-console
  console.info(SEARCH_DEBUG_PREFIX, ...args);
};

export const searchDebugWarn = (...args: any[]) => {
  if (!isSearchDebugLoggingEnabled()) return;
  // eslint-disable-next-line no-console
  console.warn(SEARCH_DEBUG_PREFIX, ...args);
};
